import { Activity } from './activity';
import { IActivity } from '../resources/activities/activity';
import { Versions } from '../constants/versions';

export interface IContextActivities {
	category?: IActivity[];
	parent?: IActivity[];
	grouping?: IActivity[];
	other?: IActivity[];
}

export interface ContextActivitiesParams {
	category?: Activity | Activity[] | IActivity | IActivity[] | string | string[];
	parent?: Activity | Activity[] | IActivity | IActivity[] | string | string[];
	grouping?: Activity | Activity[] | IActivity | IActivity[] | string | string[];
	other?: Activity | Activity[] | IActivity | IActivity[] | string | string[];
}

export class ContextActivities {
	category?: Activity[];
	parent?: Activity[];
	grouping?: Activity[];
	other?: Activity[];

	constructor(cfg: ContextActivitiesParams = {}) {
		const { category, parent, grouping, other } = cfg;

		const make_single_activity = (prop: Activity | IActivity | string): Activity => {
			if (prop instanceof Activity) {
				return prop;
			}
			if (typeof prop === 'string') {
				return new Activity({ id: prop });
			}
			return new Activity(prop);
		};

		const make_activities = (
			prop?: Activity | IActivity | string | (Activity | IActivity | string)[]
		): Activity[] | undefined => {
			if (prop === undefined) {
				return undefined;
			}
			if (Array.isArray(prop)) {
				return prop.map((v) => make_single_activity(v));
			}
			return [make_single_activity(prop)];
		};

		this.category = make_activities(category);
		this.parent = make_activities(parent);
		this.grouping = make_activities(grouping);
		this.other = make_activities(other);
	}

	asVersion(version: Versions = '1.0.3'): IContextActivities {
		const { category, parent, grouping, other } = this;
		const result: IContextActivities = {
			category: category && category.map((v) => v.asVersion(version)),
			parent: parent && parent.map((v) => v.asVersion(version)),
			grouping: grouping && grouping.map((v) => v.asVersion(version)),
			other: other && other.map((v) => v.asVersion(version))
		};

		return result;
	}

	static fromJSON(contextActivitiesJSON: string): ContextActivities {
		const _contextActivities = JSON.parse(contextActivitiesJSON);

		return new ContextActivities(_contextActivities);
	}
}
